import { Container, Title, Text, Stack, Card, Anchor } from '@mantine/core'
import { Link } from '@inertiajs/react'
import Seo from '../_Seo'
import { useI18n } from '../_i18n'
import { useLocalePath } from '../_localePath'
import { guideContent } from './content'

// Index of the science guides. `guides` (ordered slugs) comes from
// Web::PagesController#guides_index; the titles/blurbs/index chrome come from the
// localized guide-content module for the active locale.
export default function GuidesIndex({ guides = [] }) {
  const { locale } = useI18n()
  const localePath = useLocalePath()
  const content = guideContent(locale)
  const { title, description, subtitle } = content.index

  return (
    <>
      <Seo title={title} description={description} />
      <Container size="sm" py="xl">
        <Title order={1} mb="xs">
          {title}
        </Title>
        <Text c="dimmed" mb="lg">
          {subtitle}
        </Text>
        <Stack gap="md">
          {guides.map((slug) => {
            const g = content.guides[slug]
            if (!g) return null
            return (
              <Card key={slug} withBorder padding="lg" radius="md">
                <Anchor component={Link} href={localePath(`/guides/${slug}`)} fw={600} fz="lg">
                  {g.title}
                </Anchor>
                <Text c="dimmed" mt={4}>
                  {g.blurb}
                </Text>
              </Card>
            )
          })}
        </Stack>
      </Container>
    </>
  )
}
